import { ModelsTransformUtil } from '@ddt-web/common';
import * as cloneDeep from 'lodash/cloneDeep';

import { Families, FamilyPerformanceObject } from '../models';

export class FamilyPerformanceUtil {
	/**
	 * Method to fetch the model ids from the families in order on basis of dasModelOrder on model level.
	 * Map performance of each model from family performance object.
	 * In order to get inception date string with models in ordered.
	 * @param families
	 * @param familyPerformance
	 * @param familyId
	 * @param groupId
	 * @returns
	 */
	public static orderedFamilyPerformanceModelData(
		families: Families,
		familyPerformance: FamilyPerformanceObject,
		familyId: string,
		groupId: string
	): FamilyPerformanceObject {
		const orderedFamilyModelIdsInSelectedGroup = ModelsTransformUtil.sortModelPortfolios(families[familyId]?.models
			.filter(item => item?.groups?.map(element => element.id).includes(groupId)), 'dasModelOrder').map(item => item.id);
		const familyPerformanceModelsData = familyPerformance[familyId]?.models ?? [];
		const familyPerformanceCopy = cloneDeep(familyPerformance);
		const familyPerformanceModelMap = new Map();
		familyPerformanceModelsData.forEach(element => {
			familyPerformanceModelMap.set(element.id, element);
		});
		const orderedFamilyPerformanceModelData = orderedFamilyModelIdsInSelectedGroup.map(id => familyPerformanceModelMap.get(id));
		familyPerformanceCopy[familyId].models = orderedFamilyPerformanceModelData;
		return familyPerformanceCopy;
	}
}
